export default __webpack_public_path__ + "static/media/paging_next.62d3c46d.svg";